import styled from "styled-components";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  background: ${(props) => `url(${props.bg}) no-repeat`};
  background-size: cover;
  background-position-x: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px 16px;
`;

export const SkipButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 310px;

  @media screen and (max-width: 450px) {
    margin-bottom: 300px;
  }
  @media screen and (max-width: 430px) {
    margin-bottom: 270px;
  }
  @media screen and (max-width: 410px) {
    margin-bottom: 260px;
  }
  @media screen and (max-width: 390px) {
    margin-bottom: 250px;
  }
  @media screen and (max-width: 320px) {
    margin-bottom: 270px;
  }
`;

export const SkipButton = styled.div`
  cursor: pointer;
  background: #ffffff;
  color: #004f9c;
  font-weight: 400;
  font-size: 16px;
  border-radius: 16px;
  padding: 8px 16px;
  line-height: 16px;
`;

export const Title = styled.div`
  color: #e8e03c;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  width: 224px;
  margin-bottom: 15px;

  @media screen and (max-width: 350px) {
    width: 180px;
    font-size: 16px;
  }
 
`;

export const Description = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400px;
  text-align: center;
  margin-bottom: 15px;

  span {
    color: #e8e03c;
  }
  width: 55%;

  @media screen and (max-width: 420px) {
    width: 65%;
  }
  @media screen and (max-width: 350px) {
    width: 75%;
  }
  @media screen and (max-width: 310px) {
    width: 85%;
  }
`;

export const RuleTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #0161bf;
  border-radius: 12px 12px 0px 0px;
  padding: 4px 0;
`;

export const RuleTitle = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  color: #fff;
`;

export const Rule = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #808080;

  padding: 16px;
  background: #deedff;
  border-radius: 0px 0px 12px 12px;
  margin-bottom: 15px;
  width: calc(100% - 32px);
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`;

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 48px !important;
  color: ${(props) => (props.copy === "copy" ? "#0161BF" : "#FFFFFF")} !important;
  background: ${(props) =>
    props.copy === "copy"
      ? "#DEEDFF"
      : "linear-gradient(90deg, #0060BE 0%, #04AEED 100%)"} !important;
  border: none !important;
  border-radius: 16px !important;

  :hover {
    background: ${(props) =>
      props.copy === "copy"
        ? "#DEEDFF"
        : "linear-gradient(90deg, #0060BE 0%, #04AEED 100%)"} !important;
    border: none !important;
    color: ${(props) => (props.copy === "copy" ? "#0161BF" : "#FFFFFF")} !important;
  }
`;
